import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IRichTextWithTitle } from '../../interfaces/umbracoNodes/contentSlices';
import { StyledRichText } from '../base/richTextStyleWrapper/richTextStyleWrapper';
import { H3 } from '../base/typography/headings';
import RegisterShipmentCalculator from '../registerShipmentCalculator';
import * as StyledRichTextAccordion from './richTextAccordions.styles';

interface Props {
	item: IRichTextWithTitle;
}

const Accordion = ({ item }: Props) => {
	const { t } = useTranslation('common');
	const [collapsed, setCollapsed] = useState(true);

	return (
		<StyledRichTextAccordion.AccordionContainer key={item.Values.Title}>
			<StyledRichTextAccordion.AccordionHeading onClick={() => setCollapsed(!collapsed)}>
				{item.Values.Title}
				<StyledRichTextAccordion.ChevronIcon collapsed={collapsed} />
			</StyledRichTextAccordion.AccordionHeading>
			<StyledRichTextAccordion.AccordionContent collapsed={collapsed}>
				<>
					<StyledRichTextAccordion.AccordionRichTextWrapper marginBottom="4rem" marginTop="4rem">
						<StyledRichText content={item.Values.Content} />
					</StyledRichTextAccordion.AccordionRichTextWrapper>
					{item.Values.IsCalculator && (
						<>
							<H3 marginTop="4rem" marginBottom="4rem">
								{t('calculator')}
							</H3>
							<RegisterShipmentCalculator country="GB" />
						</>
					)}
					<StyledRichTextAccordion.AccordionRichTextWrapper marginTop="4rem">
						<StyledRichText content={item.Values.ContentBelowCalculator} />
					</StyledRichTextAccordion.AccordionRichTextWrapper>
				</>
			</StyledRichTextAccordion.AccordionContent>
		</StyledRichTextAccordion.AccordionContainer>
	);
};

export default Accordion;
